// this needs to be the first import since it determines the cdn location of resources
import "./../src/publicPath.ts";

import "../src/helpers/nodelist-foreach-polyfill";
import "../script/jquery.hoverintent.js";
import "../script/jquery.reveal.js";
import "../script/dropdown-menu.js";
import "../script/jquery.validate.js";
import {Tracking} from "../src/tracking/tracking";

var c = {
  config: {
    // Globale Settings
    CategoryId: 0,
    CategoryTypeId: 0,
    width: window.innerWidth > 0 ? window.innerWidth : screen.width,
    lang: "de",
    breakpointTablet: 481,
    breakpointTabletLarge: 768,
    breakpointDesktop: 940,
    breakpointDesktopLarge: 1120,
  },
  storage: {
    get(id, fromSession) {
      fromSession = typeof fromSession !== "undefined" ? fromSession : false;

      const item = fromSession ? sessionStorage.getItem(id) : localStorage.getItem(id);

      if (item === null) {
        return false;
      }

      return JSON.parse(item);
    },
    /*
     * Parameter: id, value
     */
    set(key, data, toSession) {
      toSession = typeof toSession !== "undefined" ? toSession : false;
      const item = {
        value: data,
        created: new Date().getTime(),
      };
      toSession ? sessionStorage.setItem(key, JSON.stringify(item)) : localStorage.setItem(key, JSON.stringify(item));
    },
  },
  tracking: {
    // sendEvent kapseln, damit die Funktion auf window zur Verfügung steht (für alten Code in Templates)
    sendEvent(eventName) {
      Tracking.sendEvent(eventName);
    },
  },
  sessionCookie: {
    get(key) {
      const name = key + "=";
      const decodedCookie = decodeURIComponent(document.cookie);
      const ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }

      return false;
    },
    set(key, value) {
      document.cookie = key + "=" + value + ";path=/";
    },
    remove(key) {
      document.cookie = key + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT";
    },
  },
  mailcheck(value) {
    const [, domain] = value.split("@");
    if (typeof domain === "undefined") {
      return false;
    }
    const splitByPoints = domain.split(".");
    const secondLevelDomain = splitByPoints.shift();
    if (["goglemail", "gogglemail", "googlenail", "hotnail", "gnx"].includes(secondLevelDomain)) {
      if (__DEVELOPMENT__) console.log("Wrong email! Maybe wrong second level domain:", secondLevelDomain);
      return false;
    }
    const topLevelDomain = splitByPoints.join(".");
    if (["con", "cno", "ocm"].includes(topLevelDomain)) {
      if (__DEVELOPMENT__) console.log("Wrong email! Maybe wrong top level domain:", topLevelDomain);
      return false;
    }
    return topLevelDomain.length > 1;
  },
  emailRegExp: $.validator.defaults.emailRegExp,
  init(config) {
    const conf = this.config;

    // config Parameter einlesen
    $.extend(conf, config);

    // Hauptnavigation initialisieren
    c.mainNavigation.init();

    // Sprache des Form-Validators initialisieren
    c.initValidator.init(config.lang);

    // Externe Javascript-Links initialisieren (<span data-href-blank="http://...">)
    $("[data-href-blank]").on("click", function (e) {
      e.preventDefault();
      const newTab = window.open();
      newTab.opener = null;
      newTab.location = $(this).data("href-blank");
    });

    // Interne Javascript-Links initialisieren (<span data-href="http://...">)
    $("[data-href]:not(.button-disabled)").on("click", function (e) {
      e.preventDefault();
      window.location.href = $(this).data("href");
    });

    // "Akkordeon"-Aufklappbereiche initialisieren (zur Zeit nur auf Produktdetailseiten)
    $(".accordion__item--static .accordion__item__headline > button").on("click", function () {
      const $parent = $(this).parent().parent();
      const $content = $parent.find(".accordion__item__content").first();
      const isOpen = $parent.hasClass("active");

      $parent.toggleClass("active");
      $(this).attr("aria-expanded", String(!isOpen));

      if (isOpen) {
        $content.attr("hidden", "hidden");
      } else {
        $content.removeAttr("hidden");
      }

      Tracking.sendEvent("PdsAccordionClicked");
    });

    // Formularfelder für Geburtstag initialisieren
    if ($("#Birthday").length) {
      this.initBirthday();
    }

    // Formular-Validierungs-Engine initialisieren
    const $forms = $("form.validate");
    if ($forms.length) {
      $.validator.addMethod("spellcheck", c.mailcheck, $.validator.messages.email);

      $forms.each(function () {
        $(this).validate({
          errorPlacement(error, element) {
            error.appendTo(element.parent());

            return false;
          },
          ignore: $(this).hasClass("validate-hidden") ? "" : ":hidden",
        });
      });
      $forms.find(".required input, .required select, .required textarea").each(function () {
        if (this.getAttribute("type") === "email") {
          $(this).rules("add", {spellcheck: true});
        }
        $(this).rules("add", {required: true});
      });
      $forms.find("#Password").each(function () {
        $(this).rules("add", {minlength: 8});
        $forms.find("#Password_Repeat").each(function () {
          $(this).rules("add", {equalTo: "#Password"});
        });
      });
      $forms.find("#Password_New").each(function () {
        $(this).rules("add", {minlength: 8});
        $forms.find("#Password_Repeat").each(function () {
          $(this).rules("add", {equalTo: "#Password_New"});
        });
      });
    }

    // Aufklappbare Textblöcke initialisieren (für Hilfeseiten o.ä.)
    if ($(".drop-title").length && $(".drop-content").length) {
      c.dropDownText.init();
    }

    // Aufklappbare Contentblöcke initialisieren (für Footer o.ä.)
    $(".container").on("click", ".container__item--drawer .container__item__title", function () {
      $(this).parent().toggleClass("container__item--drawer-open");
    });

    // Ggf. Formular-Felder mittels Localstorage wieder befüllen
    if (localStorage) {
      c.formStorage(true);
    }

    // Liste der Artikelbewertungen initialisieren
    this.initProductReview();

    // Promobanner fixiert unten
    const $TopBarBottom = $(".top-bar--bottom");
    if ($TopBarBottom.length) {
      (function () {
        const thresh = 60;
        const $window = $(window);
        let visible = window.scrollY < thresh;
        if (!visible) $TopBarBottom.slideUp();
        $window.on(
          "scroll",
          c.throttle(function () {
            if (visible && window.scrollY >= thresh) {
              $TopBarBottom.slideUp(200);
              visible = !visible;
            } else if (!visible && window.scrollY < thresh) {
              $TopBarBottom.slideDown(200);
              visible = !visible;
            }
          }, 200),
        );
      })();
    }

    // Toggle-Button (Mobilansicht) für Filterlisten initialisieren
    const $mobiletogglebutton = $(".mobile-toggle-button");
    if ($mobiletogglebutton.length) {
      $mobiletogglebutton.on("click", function () {
        $(".mobile-toggle").toggleClass("mobile-toggle-show");
        $(".mobile-toggle-button>span").toggleClass("icon-chevron-down").toggleClass("icon-chevron-up");
      });
    }

    // Löschformular im Kundenkonto initialisieren
    const $AccountDeletionForm = $("#AccountDeletionForm");
    if ($AccountDeletionForm.length) {
      c.accountDeletion($AccountDeletionForm);
    }

    // Blog-News
    this.blogNews.init();

    // Lese-Fortschritt initialisieren
    const $ProgressContainer = $(".progress-container");
    if ($ProgressContainer.length) {
      (function () {
        const $window = $(window);
        const $blogEntryTop = $(".blog-entry");
        const $blogEntryBottom = $(".blog-entry + section");

        let winHeight;
        let blog_entry_top;
        let blog_entry_bottom;
        let blog_height;

        let curr_abs_pos;
        let curr_blog_pos;
        let curr_value;
        let curr_percent_val;

        let visible = false;
        const getTransform = function (value) {
          const prefixes = ["", "-webkit-", "-ms-"];
          let css = "";
          Array.prototype.forEach.call(prefixes, function (prefix) {
            css += prefix + "transform: scale(" + value.toFixed(4) + ",1);";
          });

          return css;
        };

        $window.on(
          "scroll",
          c.throttle(function () {
            curr_abs_pos = $window.scrollTop();
            curr_blog_pos = curr_abs_pos - blog_entry_top;
            curr_value = curr_blog_pos / blog_height;
            curr_percent_val = curr_value * 100.0;

            $(".progress-bar", $ProgressContainer).attr({style: getTransform(curr_value)});

            if (curr_percent_val >= 0.0 && curr_percent_val <= 102.0 && !visible) {
              $ProgressContainer.addClass("visible");
              visible = true;
            } else if ((curr_percent_val < 0.0 || curr_percent_val > 104.0) && visible) {
              $ProgressContainer.removeClass("visible");
              visible = false;
            }
          }, 200),
        );

        $window.resize(function () {
          winHeight = $window.height();
          blog_entry_top = $blogEntryTop.offset().top;
          blog_entry_bottom = $blogEntryBottom.offset().top - winHeight;
          blog_height = blog_entry_bottom - blog_entry_top;
          $window.scroll();
        });

        $window.resize();
      })();
    }

    // Neuheiten mit Ambientebild auf der Startseite
    const $NewProductsBlock = $("#NewProductsBlock");
    if ($NewProductsBlock.find(".list-products a").length) {
      $NewProductsBlock.show();
    }

    // Breadcrumbs nach dem Laden oder beim resize immer Rechtsbündig anzeigen
    const bc = document.querySelector("#breadcrumb");
    if (bc !== null) {
      $(window).on("load resize", function () {
        bc.scrollLeft = 9999;
      });
    }

    // Teaser Block Buttons zum Aufklappen auf Brand Shop Seiten in der Desktop-Ansicht
    const teaserButtons = document.querySelectorAll(".button-teaser-show");
    if (teaserButtons.length) {
      teaserButtons.forEach(function (teaserButton) {
        // Alle Halbtransparenten und Unsichtbaren vorab speichern
        const ParentSection = document.querySelector(teaserButton.dataset.parentSectionId);
        const hiddenElements = ParentSection.querySelectorAll(".max-tablet");
        const hollowElements = ParentSection.querySelectorAll(".teaser-wrapper__swiper--item--hollow");

        teaserButton.addEventListener("click", function () {
          // gerade im eingeklappten Modus?
          const isInHiddenState = teaserButton.dataset.state === "hidden";

          // versteckte Elemente ab 9. Element/3. Zeile, Sichtbarkeit in Desktop-Ansicht togglen
          if (hiddenElements.length) {
            hiddenElements.forEach(function (hiddenElement) {
              // wenn eingeklappt: mit .max-tablet class in Desktop-Ansicht (min-height: 768px)
              // unsichtbar machen, mobil kein Effekt, weil immer sichtbar und css-Slider
              isInHiddenState
                ? hiddenElement.classList.remove("max-tablet")
                : hiddenElement.classList.add("max-tablet");
            });
          }

          // halbtransparente Teaserelemente, 5.-8. Element in der zweiten Zeile, opacity in Desktop-Ansicht togglen
          if (hollowElements.length) {
            hollowElements.forEach(function (hollowElement) {
              // wenn eingeklappt: mit '..--hollow' class in desktop (min-height: 768px)
              // halbtransparent, mobil kein Effekt, weil komplett sichtbar und css-Slider
              isInHiddenState
                ? hollowElement.classList.remove("teaser-wrapper__swiper--item--hollow")
                : hollowElement.classList.add("teaser-wrapper__swiper--item--hollow");
            });
          }

          // hidden state und Wording togglen
          if (isInHiddenState) {
            teaserButton.dataset.state = "shown";
            teaserButton.innerText = teaserButton.dataset.hideAllText;
          } else {
            teaserButton.dataset.state = "hidden";
            teaserButton.innerText = teaserButton.dataset.showAllText;
          }
        });
      });
    }

    // Blende den DeliveryNoticeBanner ein, wenn die Browsersprache auf en-GB oder en-US eingestellt ist
    const deliveryNoticeBanner = document.getElementById("DeliveryNoticeBanner");
    if (deliveryNoticeBanner && (navigator.language === "en-GB" || navigator.language === "en-US"))
      deliveryNoticeBanner.style.display = "block";

    let initWindowSize = $(window).width();

    $(window).resize(function () {
      // Seite einmalig Neuladen, wenn der User von der Desktop Ansicht zur Mobile Ansicht wechselt (z.B. durch Zoom-In oder Verkleinern des Browserfensters)
      if (initWindowSize >= c.config.breakpointTabletLarge && $(window).width() < c.config.breakpointTabletLarge) {
        window.location.reload();
        // Setze die Variable auf die neue mobile Fenstergröße, damit die Funktion nicht wiederholt durchgeführt wird
        initWindowSize = $(window).width();
      }
    });
  },

  throttle(func, wait) {
    let context;
    let args;
    let result;
    let timeout = null;
    let previous = 0;
    const later = function () {
      previous = date_now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var date_now =
      Date.now ||
      function () {
        return new Date().getTime();
      };

    return function () {
      const now = date_now();
      const remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout) {
        timeout = setTimeout(later, remaining);
      }

      return result;
    };
  },

  revealPopup(selector) {
    $(selector).reveal({
      animation: "fade",
      animationspeed: 200,
      closeonbackgroundclick: true,
    });
  },

  initRatingForm(url, itemId) {
    $("#PluginContainer").load(url, function () {
      $("#ProductRatingFormContainer").find("#ItemId").val(itemId);
      const $form = $("form.validate");
      $form.validate({
        errorPlacement(error, element) {
          if (element[0].name == "Rating") {
            error.appendTo(element.parent().parent());
          } else {
            error.appendTo(element.parent());
          }
        },
        rules: {
          Rating: {
            required: true,
          },
          Subject: {
            required: true,
            minlength: 10,
          },
          Content: {
            required: true,
            minlength: 50,
          },
        },
      });
    });
    $("#RatingPopup").reveal();

    return false;
  },

  initValidator: {
    messages: {
      de: {
        required: "Dies ist ein Pflichtfeld.",
        minlength: $.validator.format("Geben Sie bitte mindestens {0} Zeichen ein."),
        email: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
        equalTo: "Die Eingaben stimmen nicht überein.",
      },
      da: {
        required: "Dette felt er påkrævet.",
        minlength: $.validator.format("Indtast mindst {0} tegn."),
        email: "Indtast en gyldig email-adresse.",
        equalTo: "Indtast den samme værdi igen.",
      },
      fr: {
        required: "Ce champ est obligatoire.",
        email: "Veuillez fournir une adresse électronique valide.",
        equalTo: "Veuillez fournir encore la même valeur.",
        minlength: $.validator.format("Veuillez fournir au moins {0} caractères."),
      },
    },

    init(lang) {
      const msgObj = this.messages[lang];

      // falls jemals 'require.js' verwendet wird, hier code aus
      // den 'jquery.validate.messages_{lang}.js' zur rate ziehen
      $.extend($.validator.messages, msgObj);
    },
  },

  blogNews: {
    init() {
      const $blogNewsDiv = $("#BlogNews");
      if ($blogNewsDiv.length) {
        const blogNewsData = sessionStorage.getItem("c_BlogNewsData");
        if (blogNewsData !== null) {
          c.blogNews.fillSlots($blogNewsDiv, $.parseXML(blogNewsData));

          return;
        }

        const c_BlogNewsDataPath = window.c_BlogNewsDataPath || "";
        if (c_BlogNewsDataPath != "") {
          $.get(
            c_BlogNewsDataPath,
            function (data) {
              sessionStorage.setItem("c_BlogNewsData", data);
              c.blogNews.fillSlots($blogNewsDiv, $.parseXML(data));
            },
            "text",
          );
        } else {
          $blogNewsDiv.closest("section").remove();
        }
      }
    },
    fillSlots($blogNewsDiv, data) {
      const $blogNewsAnchors = $("a.list-products__item", $blogNewsDiv);
      const blogEntries = Array.from(data.getElementsByTagName("BlogEntry"));

      $blogNewsAnchors.each(function (i) {
        $(this).attr({
          "href": $("Path", blogEntries[i]).text(),
          "data-cid": $("CategoryId", blogEntries[i]).text(),
          "data-ctid": $("CategoryTypeId", blogEntries[i]).text(),
        });
        $(this).append($("Name", blogEntries[i]).text());
        $("img", this).attr("src", $("Banner", blogEntries[i]).text());
        $("img", this).attr("alt", $("ImgAltText", blogEntries[i]).text());
      });
      $blogNewsDiv.show();
    },
  },

  mainNavigation: {
    init() {
      // Automatisches Scrollen bei Browserback verhindern, wenn die Navigation zuvor offen war (nur mobil relevant)
      if (history.state && history.state.navOpened && history.scrollRestoration) {
        history.scrollRestoration = "manual";
      } else {
        // Automatisches Scrollen erlauben, wenn die Navigation nicht offen war (wichtig für PLPs)
        history.scrollRestoration = "auto";
      }

      // Zuerst Initial-State setzen: Navigation ist nicht geöffnet (nur mobil relevant)
      history.replaceState(Object.assign({}, history.state, {navOpened: 0}), "");

      c.mainNavigation.readLastMenuItem();

      // Hauptnavigation öffnen (nur mobil relevant)
      $("#MobileNavButton").on("click", function () {
        c.mainNavigation.openHeader();
        c.mainNavigation.openMobileNav();
      });

      // Hauptnavigation schließen (nur mobil relevant)
      $("#MobileNavCloseButton, #MobileNavCloseButtonHidden").on("click", function () {
        c.mainNavigation.closeMobileNav();
        c.mainNavigation.closeHeader();
        c.mainNavigation.deleteLastMenuItem();
      });

      // "Vor"- und "Zurück"-Events abfangen und ggf. Navigation öffnen/schließen
      window.addEventListener("popstate", function (event) {
        // Sicherstellen, dass das Event gemäß Spezifikation befüllt ist, gibt sonst Probleme mit PhantomJS
        if (event.state !== null && event.state.navOpened !== null) {
          if (event.state.navOpened === 1) {
            $("header").addClass("open");
          } else {
            c.mainNavigation.closeMobileNav();
            $("header").removeClass("open");
          }
        }
      });

      // Suche-Dropdown öffnen (Desktop)
      $("#OpenSearchButtonDesktop").on("click", function () {
        $(".main-nav li").removeClass("nav-open nav-active").removeClass("subnav-open subnav-active");
        $(".main-nav div").removeClass("move-layer");
      });

      // Mobile Navi schließen
      $("#OpenSearchButtonMobile").on("click", function () {
        c.mainNavigation.closeMobileNav();
        history.pushState(Object.assign({}, history.state, {navOpened: 1}), "");
      });

      $("#CloseSearchButtonMobile").on("click", function () {
        history.replaceState(Object.assign({}, history.state, {navOpened: 0}), "");
      });

      // Navi schließen wenn ESC gedrückt wird und ggf. den zuletzt geöffneten Hauptmenüpunkt focusieren (wegen Barrierefreiheit)
      $(document).on("keyup", function (e) {
        if (e.key === "Escape" && $(".nav-open").length) {
          if ($("header").hasClass("open")) {
            c.mainNavigation.closeMobileNav();
            c.mainNavigation.closeHeader();
            c.mainNavigation.deleteLastMenuItem();
            $("#MobileNavButton").focus();
          } else {
            $(".main-nav li.nav-open .toggle-btn-subnav").focus();
            c.mainNavigation.closeSubNav(".main-nav li.nav-open");
          }
        }
      });

      // Andere Menüs schließen, wenn per Tastaturnavigation ein Menüitem fokussiert wird
      $(".main-nav .main-nav-link > a").on("focus", function () {
        $(this).parent().siblings().removeClass("nav-open");
      });

      // Navigations-Dropdowns öffnen und schließen
      if ($(window).width() >= c.config.breakpointTabletLarge) {
        /* Desktopansicht:
         * HoverIntent sorgt für saubere UX: Menü wird nur geöffnet, wenn der Benutzer wirklich darauf zeigt,
         * nicht wenn er nur schnell mit der Maus darüberfährt */
        // Haupt-Navigation:
        $(".main-nav .main-nav-link--flyout")
          .hoverIntent({
            over() {
              if ($(this).hasClass("nav-open")) {
                return;
              }
              // Bei HoverIntent: Menü öffnen
              c.mainNavigation.openSubNav(this);
            },
            out() {
              // Beim Verlassen, Menü und Untermenü-Ebenen schließen, aber erst nach timeout
              c.mainNavigation.closeSubNav(this);
            },
            interval: 50, // internes Prüfinterval für das HoverIntent-Script, 50 ms sorgt für gute "Responsiveness"
            timeout: 400, // wenn die Maus das Menü verlässt, 400 ms warten vorm Schließen
          })
          .on("touchstart", function (e) {
            // Außerdem: Beim antippen des Nav-Elements auf einem Touchscreen mit Tablet-Größe:
            // Untermenü öffnen, anstatt Link zu folgen (wenn es nicht schon geöffnet ist)
            if ($(this).hasClass("nav-open")) {
              return;
            }
            e.preventDefault();
            c.mainNavigation.openSubNav(this);
            $(this).addClass("nav-active");

            // Schließe alle anderen Untermenü-Ebenen
            const $menuLiSiblings = $(this).siblings();
            c.mainNavigation.closeSubNav($menuLiSiblings);
          });

        $(".main-nav .main-nav-link--flyout .toggle-btn-subnav").on("keydown", function (e) {
          if (e.key === "Enter") {
            const $menuLi = $(this).parent();
            const $menuLiSiblings = $menuLi.siblings();

            if ($menuLi.hasClass("nav-open")) {
              c.mainNavigation.closeSubNav($menuLi);
            } else {
              c.mainNavigation.closeSubNav($menuLiSiblings);
              c.mainNavigation.openSubNav($menuLi);
            }

            e.preventDefault();
            e.stopPropagation();
          }
        });

        // Flyout-Navigation Untermenüs:
        $(".subnav-link")
          .hoverIntent({
            over(e) {
              const $subnavAside = $(e.target).closest(".subnav-aside").length;

              if ($(this).hasClass("subnav-open")) {
                return;
              }

              // Öffne die nächste Untermenü-Ebene, wenn es eine gibt
              if ($(this).hasClass("subnav-link--flyout")) {
                $(this).addClass("subnav-open subnav-active");
                $(this).find(".toggle-btn-subnav-layer").first().attr("aria-expanded", "true");
              }

              // Schließe alle unerwünschten Untermenü-Ebenen und passe die Höhe des Wrappers an (außer wenn man in die rechte Spalte hovert)
              if (!$subnavAside) {
                c.mainNavigation.closeSiblingSubNavLayer(this);
                c.mainNavigation.calcSubNavHeight(this);
              }
            },
            out() {
              return null;
            },
            interval: 50, // Prüfinterval für gute "Responsiveness"
          })
          .on("touchstart", function (e) {
            // Außerdem: Beim antippen des Nav-Elements auf einem Touchscreen mit Tablet-Größe:
            // Nächste Untermenü-Ebene öffnen, anstatt Link zu folgen (wenn es nicht schon geöffnet ist)
            if ($(this).hasClass("subnav-open")) {
              return;
            }
            if ($(this).hasClass("subnav-link--flyout")) {
              e.preventDefault();
              // Füge außerdem das "hover" Styling für Touchscreens hinzu (subnav-active)
              $(this).addClass("subnav-open subnav-active");
              $(this).find(".toggle-btn-subnav-layer").first().attr("aria-expanded", "true");
              c.mainNavigation.calcSubNavHeight(this);
            }

            // Schließe alle unerwünschten Untermenü-Ebenen
            c.mainNavigation.closeSiblingSubNavLayer(this);
          });

        $(".subnav-link .toggle-btn-subnav-layer").on("keydown", function (e) {
          if (e.key === "Enter") {
            const $menuLi = $(this).parent();
            if ($menuLi.hasClass("subnav-open")) {
              $(this).attr("aria-expanded", "false");
              $menuLi.removeClass("subnav-open subnav-active").find("li").removeClass("subnav-open subnav-active");
            } else {
              c.mainNavigation.closeSiblingSubNavLayer($menuLi);
              $(this).attr("aria-expanded", "true");
              $menuLi.addClass("subnav-open subnav-active");
              c.mainNavigation.calcSubNavHeight($menuLi);
            }
            e.preventDefault();
            e.stopPropagation();
          }
        });

        // Schließe alle offenen Untermenüs auf Touchscreens, wenn außerhalb der Navi getippt wird
        $(document).on("touchstart", function (e) {
          const $menuItems = $(".main-nav").find("li");
          const isSubnavOpen = $menuItems.hasClass("nav-open");
          const areaOutsideOfNavi = $(e.target).closest(".main-nav").length === 0;

          if (isSubnavOpen && areaOutsideOfNavi) {
            $menuItems.removeClass("nav-open nav-active").removeClass("subnav-open subnav-active");
            $(".main-nav").find("button").attr("aria-expanded", "false");
            $("a")
              .not(".main-nav a")
              .one("click", function (event) {
                event.preventDefault();
              });
          }
        });
      } else {
        /* Mobilansicht:
         * Nav-Dropdowns lassen sich beliebig auf- und zuklappen.
         * Direktes anspringen der Links ist dafür nicht mehr möglich. */
        // Mobile Haupt-Navigation (1. Ebene):
        $(".main-nav .main-nav-link--flyout > a").on("click", function (e) {
          e.preventDefault();
          $(this).parent().addClass("nav-open").siblings().removeClass("nav-open");
        });

        // Mobile Flyout-Navigation der Untermenüs:
        $(".subnav-link--flyout > a").on("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          const $this = $(this);
          // Öffne das dazugehörige Untermenü und schließe alle anderen Untermenüs
          $this.parent().addClass("subnav-open").siblings().removeClass("subnav-open");
          // Verschiebe die vorherigen Ebene nach links
          $this.closest(".subnav-layer").addClass("move-layer");
        });

        // Schließe die Untermenü-Ebene und springe zurück zur vorherigen Ebene
        $(".subnav-back").on("click", function (e) {
          $(this).closest(".subnav-open").removeClass("subnav-open").closest(".move-layer").removeClass("move-layer");
          e.stopPropagation();
        });

        $(".subnav-layer--one > .subnav-back").on("click", function (e) {
          $(this).closest(".nav-open").removeClass("nav-open");
          e.stopPropagation();
        });

        $(".subnav-link > a").on("focus", function () {
          $(this).parent().siblings().removeClass("subnav-open").closest(".subnav-layer").removeClass("move-layer");
        });
      }
      $(".main-nav-link a").on("click", c.mainNavigation.cacheLastMenuItem);
    },
    cacheLastMenuItem(evt) {
      evt.stopPropagation();

      // ignore on main navigation item
      if (evt.target.parentNode.classList.contains("main-nav-link")) return;
      const allTitles = [evt.target.title.trim()];

      // Current list item
      let closestListItem = evt.target.closest("li, .subnav-aside");
      let containingList;

      while (closestListItem) {
        containingList = closestListItem.closest("ul");
        closestListItem = containingList.closest(".subnav-link");

        // .firstElementChild should be the headlining anchor
        if (closestListItem) allTitles.push(closestListItem.firstElementChild.title.trim());
      }
      const mainNav = containingList.closest(".main-nav-link--flyout");
      if (mainNav) allTitles.push(mainNav.firstElementChild.title);

      c.storage.set(c.mainNavigation.lastMenuItemKey, allTitles, true);
    },
    restoreLastMenu() {
      c.mainNavigation.lastMenuItem.shift();
      if (!c.mainNavigation.lastMenuItem.length) return;

      const mainTitle = c.mainNavigation.lastMenuItem.pop();
      const mainSelector = "nav .main-nav-link>a[title='" + mainTitle + "']";
      const firstAnchor = document.body.querySelector(mainSelector);

      let listEntry = firstAnchor.parentElement;
      listEntry.classList.add("nav-open");

      while (c.mainNavigation.lastMenuItem.length) {
        const title = c.mainNavigation.lastMenuItem.pop();
        const nextSelector = ".subnav-link>a[title='" + title + "']";
        const nextEntry = listEntry.querySelector(nextSelector);

        c.mainNavigation.calcSubNavHeight(listEntry);
        listEntry = nextEntry.parentElement;
        listEntry.classList.add("subnav-open");

        if ($(window).width() >= c.config.breakpointTabletLarge) {
          listEntry.classList.add("subnav-active");
          c.mainNavigation.calcSubNavHeight(listEntry);
        }

        const subNavLayer = listEntry.closest(".subnav-layer");
        if (subNavLayer) subNavLayer.classList.add("move-layer");
      }
    },
    lastMenuItemKey: "last_menu_item",
    lastMenuItem: [],
    readLastMenuItem() {
      const storageEntry = c.storage.get(c.mainNavigation.lastMenuItemKey, true);
      if (storageEntry) this.lastMenuItem = storageEntry.value;
    },
    deleteLastMenuItem() {
      sessionStorage.removeItem(c.mainNavigation.lastMenuItemKey);
    },
    openHeader() {
      $("header").addClass("open");
      // History-State setzen, damit der Zurück-Button des Browsers die Navigation schließen kann
      history.pushState(Object.assign({}, history.state, {navOpened: 1}), "");
    },
    closeHeader() {
      $("header").removeClass("open");
      history.replaceState(Object.assign({}, history.state, {navOpened: 0}), "");
    },
    openMobileNav() {
      $("header").addClass("nav-open");
      $("body").addClass("no-scroll");
      c.mainNavigation.restoreLastMenu();
    },
    closeMobileNav() {
      $("header").removeClass("nav-open");
      $("body").removeClass("no-scroll");
      $(".main-nav li").removeClass("nav-open").removeClass("subnav-open");
      $(".main-nav div").removeClass("move-layer");
    },
    calcSubNavHeight(element) {
      const $el = $(element);
      const navMinHeight = 466;
      // Berechne die Höhe der aktuellsten sowie der vorherigen Untermenü-Ebene (plus 16px padding)
      const prarentLayerHeight = $el.parent().outerHeight() + 16;
      const currentListHeight = $el.find("ul").first().outerHeight() + 16;
      // Wähle, aus den drei Variablen, die größte Höhe aus
      let largestHeight = Math.max(currentListHeight, prarentLayerHeight, navMinHeight);

      if (!$el.hasClass("subnav-link--flyout")) {
        largestHeight = Math.max(prarentLayerHeight, navMinHeight);
      }

      // Passe die Höhe des Nav-Dropdown Wrappers an
      $el.closest(".subnav-wrapper").css({
        height: largestHeight + "px",
      });
    },
    openSubNav(element) {
      const navMinHeight = 450;
      const subNavUL = $(element).find(".subnav-layer--one").find("ul").first();
      const mainMenuAnchor = $(element).find("> a");
      const lastMenuTitle = c.mainNavigation.lastMenuItem[c.mainNavigation.lastMenuItem.length - 1];
      const mainMenuTitle = mainMenuAnchor.attr("title");
      const toggleBtn = $(element).find(".toggle-btn-subnav").first();

      $(element).addClass("nav-open");

      // Tracking-Informationen an GTM senden
      Tracking.setVariable("LastOpenedNavigation", mainMenuAnchor.text().trim());
      Tracking.sendEvent("trackNavigationOpened");

      // Höhe des wrappers aktualisieren (aber erst nachdem bereits die Klasse "nav-open" hinzugefügt wurde)
      $(element)
        .find(".subnav-wrapper")
        .css({
          height: Math.max(subNavUL.outerHeight(), navMinHeight) + 16 + "px",
        });

      if (mainMenuTitle === lastMenuTitle) {
        c.mainNavigation.restoreLastMenu();
      }
      if (toggleBtn.length) {
        toggleBtn.attr("aria-expanded", "true");
      }
    },
    closeSubNav(element) {
      $(element).find("button").attr("aria-expanded", "false");
      $(element).removeClass("nav-open nav-active").find("li").removeClass("subnav-open subnav-active");
    },
    closeSiblingSubNavLayer(element) {
      $(element)
        .siblings()
        .removeClass("subnav-open subnav-active")
        .find("li")
        .removeClass("subnav-open subnav-active");
      $(element).siblings().find("button").attr("aria-expanded", "false");
    },
  },
  initProductReview() {
    const $list = $(".product-review-list");
    if (!$list.length) return;
    const $more = $list.find(".product-review-list__more");
    if (!$more.length) return;

    $more.show().on("click", function () {
      $list.addClass("show-all");
      $more.remove();
    });
  },

  /**
   * Geburtstags-Formularfelder initialisieren
   */
  initBirthday() {
    $(".BirthdayDay").on("change", function () {
      $(".BirthdayDay").val($(this).val());
      const newDate =
        $(".BirthdayYear").first().val() +
        "-" +
        $(".BirthdayMonth").first().val() +
        "-" +
        $(".BirthdayDay").first().val();
      if (newDate.length === 10) {
        $("#Birthday").val(newDate);
      } else {
        $("#Birthday").val("");
      }
    });
    $(".BirthdayMonth").on("change", function () {
      $(".BirthdayMonth").val($(this).val());
      const newDate =
        $(".BirthdayYear").first().val() +
        "-" +
        $(".BirthdayMonth").first().val() +
        "-" +
        $(".BirthdayDay").first().val();
      if (newDate.length === 10) {
        $("#Birthday").val(newDate);
      } else {
        $("#Birthday").val("");
      }
    });
    $(".BirthdayYear").on("change", function () {
      $(".BirthdayYear").val($(this).val());
      const newDate =
        $(".BirthdayYear").first().val() +
        "-" +
        $(".BirthdayMonth").first().val() +
        "-" +
        $(".BirthdayDay").first().val();
      if (newDate.length === 10) {
        $("#Birthday").val(newDate);
      } else {
        $("#Birthday").val("");
      }
    });
  },

  dropDownText: {
    init() {
      const contents = $(".drop-content").hide();
      const drops = $(".drop-title").on("click", function () {
        const $this = $(this);
        $this.find(".h2").toggleClass("open");
        $this.next(".drop-content").slideToggle();
      });

      contents.find("a").on("click", function (e) {
        const $this = $(this);
        const hash = $this.prop("hash");
        if (hash.length) {
          if ($(hash).length) {
            const $title = $(hash).closest(".drop-title");
            document.location.hash = hash;
            $title.find(".h2").addClass("open");
            $title.next(".drop-content").slideDown();
            $("html, body").animate({scrollTop: $title.offset().top}, "fast");
            e.preventDefault();
          }
        }
      });

      if (document.location.hash) {
        $(document.location.hash)
          .closest(".drop-title")
          .find(".h2")
          .addClass("open")
          .end()
          .next(".drop-content")
          .slideDown();
      }
    },
  },

  accountDeletion($form) {
    const $select = $form.find("select");
    const $text = $form.find("#ReasonText");
    const $otherBlock = $form.find("#Other");
    const $otherInput = $form.find("#OtherText");
    const prefix = $text.data("prefix");

    $select.on("change", function () {
      const $this = $(this);
      switch ($this.val()) {
        case "none":
          $otherBlock.hide();
          $text.val("");
          break;
        case "other":
          $text.val("");
          $otherBlock.show();
          break;
        default:
          $otherBlock.hide();
          $text.val(prefix + " " + $this.val());
      }
    });
    $otherInput.on("keyup", function () {
      $text.val(this.value.length > 3 ? prefix + " " + this.value : "");
    });
  },

  /*
   * Usage:
   * <form data-save="" >...
   *   <div data-save="FIELD_IDENTIFIER" >
   *       <input  />
   *   </div>
   *   <div data-save="FIELD_IDENTIFIER2" >
   *       <input  />
   *   </div>
   * </form>
   *
   * Bei Bedarf erweiterbar für andere Formulare.
   * Derzeit wird nur das aktuelle Formular gespeichert.
   *
   * (bool) useSession SessionStorage, sonst localStorage
   *
   * ck 12-03-2014
   */
  formStorage(useSession) {
    var useSession = typeof useSession !== "undefined" ? useSession : false;
    const storageKey = "FormStorage";

    if (!$("form[data-save]").length) {
      useSession ? sessionStorage.removeItem(storageKey) : localStorage.removeItem(storageKey);

      return;
    }

    const $form = $("form[data-save]");
    const $items = $form.find("[data-save]");
    const fromStorage = c.storage.get(storageKey, true);

    if (fromStorage) {
      $.each($items, function (index, element) {
        const $element = $(element);
        $element.find("input").val(fromStorage.value[$element.data("save")]);
      });
    }

    $form.on("submit", function () {
      const toStorage = {};
      $.each($items, function (index, element) {
        const $element = $(element);
        const $input = $element.find("input");
        toStorage[$element.data("save")] = $input.val();
      });
      c.storage.set(storageKey, toStorage, true);
    });
  },
};

window.c = c;

$(document).ready(function () {
  c.init({lang: $("body").data("lang")});
});
